module.exports = __webpack_public_path__ + "media/images/video/akt-app-promo-a61b53a4a4b7a9cb90d98d44cd68f476.png";